/**
 * Client-side identifier for a fact-find entity (an asset, liability, income item, capital expense,
 * or client structure). These ids exist only to tell one row from another within a profile's working
 * data — they are never database keys.
 *
 * A proper UUID, not a timestamp: the previous `Date.now()` scheme collided whenever two rows were
 * created in the same millisecond (e.g. importing several assets at once), which is why the import
 * path had to hand-roll an incrementing offset. `crypto.randomUUID()` removes the collision entirely.
 */
export function newEntityId(): string {
    return crypto.randomUUID();
}
